<div class="profile-container">
  <div class="">
    <div class="profile-content">

      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">

            <div class="search">
              <form autocomplete="off">
                <input type="text" placeholder="search" (keyup.enter)="getAllUserTypeByWildSearchWithoutPagination()"
                  [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
              </form>
              <i class="bi bi-search" (click)="getAllUserTypeByWildSearchWithoutPagination()"></i>
            </div>

            <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i
                class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
            <div class="filter-icon">
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
            </div>

          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 80%;">User Types</th>
              <th style="width: 20%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>

            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" *ngFor="let record of userTypeData | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                        }  ;let i = index">
            <p style="width: 80%;">
              <span *ngFor="let type of record.userTypes; let last = last">{{type}}<span *ngIf="!last">, </span></span>
            </p>
            <p class="action-buttons" style="width: 20%;padding-left: 25px;">
              <i *ngIf="actionControls.isModify || actionControls.isView" (click)="getUserTypeById(record.id)"
                title="Edit/View" class="bi bi-pencil" data-toggle="modal" data-target="#exampleModalEdit"></i>
              <i *ngIf="actionControls.isDelete" (click)="selectDelete(record.id, record)" title="Delete"
                class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i>
            </p>
          </div>
        </div>

        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && userTypeData.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>
        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="count" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
        </div>

      </div>

    </div>
  </div>
</div>

<!-- Add Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add User Type
          <span data-dismiss="modal">
            <i (click)="formReset()" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
          <div class="row">
            <!-- <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>ID <span class="required">*</span></label>
                <input formControlName="id" type="text" class="form-control">
              </div>
            </div> -->

            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>{{ 'uom-master.description' | translate }}</label>
                <textarea class="form-control" formControlName="description" cols="30" rows="10"></textarea>
              </div>
            </div>

            <div class="col-md-12 col-lg-12">
              <div formArrayName="userTypes">
                <div *ngFor="let param of form.controls.userTypes['controls'];let i = index;let last = last"
                  [formGroupName]="i">
                  <div class="row">
                    <div class="col-md-11 col-lg-11">
                      <div class="form-group">
                        <input formControlName="type" placeholder="enter user type" type="text" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-1 col-lg-1 paramBtn" *ngIf="last">
                      <svg xmlns="http://www.w3.org/2000/svg" (click)="addUserTypeObject()" fill="currentColor"
                        class="bi bi-plus-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path
                          d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removeUserTypeObject(i)"
                        fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                      </svg>
                    </div>
                    <div class="col-md-1 col-lg-1 paramBtn1" *ngIf="!last">
                      <svg xmlns="http://www.w3.org/2000/svg" (click)="removeUserTypeObject(i)" fill="currentColor"
                        class="bi bi-dash-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton" (click)="formReset()" class="btn btn-secondary"
          data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        <button type="button" (click)="addUserType()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit / View Modal -->
<div class="modal fade" id="exampleModalEdit" tabindex="-1" data-backdrop="static"
  aria-labelledby="exampleModalLabelEdit" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabelEdit">Edit User Type
          <span data-dismiss="modal">
            <i (click)="formReset()" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="editForm">
          <div class="row">


            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>{{ 'uom-master.description' | translate }}</label>
                <textarea class="form-control" formControlName="description" cols="30" rows="10"></textarea>
              </div>
            </div>

            <div class="col-md-12 col-lg-12">
              <div formArrayName="userTypes">
                <div *ngFor="let param of editForm.controls.userTypes['controls'];let i = index;let last = last"
                  [formGroupName]="i">
                  <div class="row">
                    <div class="col-md-11 col-lg-11">
                      <div class="form-group">
                        <input formControlName="type" placeholder="enter user type" type="text" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-1 col-lg-1 paramBtn" *ngIf="last">
                      <svg xmlns="http://www.w3.org/2000/svg" (click)="addEditUserTypeObject()" fill="currentColor"
                        class="bi bi-plus-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path
                          d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removeEditUserTypeObject(i)"
                        fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                      </svg>
                    </div>
                    <div class="col-md-1 col-lg-1 paramBtn1" *ngIf="!last">
                      <svg xmlns="http://www.w3.org/2000/svg" (click)="removeEditUserTypeObject(i)" fill="currentColor"
                        class="bi bi-dash-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Allow adding if list is empty -->
              <div *ngIf="editForm.controls.userTypes['controls'].length === 0" style="margin-top: 10px;">
                <button type="button" class="btn btn-sm btn-primary" (click)="addEditUserTypeObject()">Add User
                  Type</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButtonEdit" class="btn btn-secondary" (click)="formReset()"
          data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        <button type="button" (click)="updateUserType()" class="btn btn-primary"
          *ngIf="actionControls.isModify">Update</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="closeModal()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
        <div class="modal-footer">
          <button type="button" id="deleteModalButton" (click)="closeModal()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleteUserTypeAction()" class="btn btn-primary">{{ 'generic.delete' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>